import { createRestSlice } from "./restSlice";

export type AgentTemplate = {
  id: string;
  name: string;
  description: string | null;
  category: string | null;
  isPublic: boolean;
  variables: { name: string; label: string; description?: string; type: string; required: boolean; default?: string }[];
  files: Record<string, string> | null;
  organizationId: string | null;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
};

const agentTemplateSlice = createRestSlice<AgentTemplate>("agentTemplate", "/v1/agent-templates");

export const agentTemplateReducer = agentTemplateSlice.reducer;
export const agentTemplateActions = agentTemplateSlice.actions;
